import { Link } from 'react-router-dom';

export default function TalentCard({ talent }) {
  const defaultImage = "https://images.unsplash.com/photo-1622169804256-0eb6873ff441?w=400&h=500&fit=crop";
  
  return (
    <Link 
      to={`/talent/${talent.id}`} 
      className="card talent-card"
      data-testid={`talent-card-${talent.id}`}
    >
      <div className="talent-card-image">
        <img 
          src={talent.headshot_url || defaultImage} 
          alt={talent.name}
          onError={(e) => { e.target.src = defaultImage; }}
        />
      </div>
      <div className="talent-card-content">
        <h3 className="talent-card-name">{talent.name}</h3>
        <p className="talent-card-info">
          {talent.representation_type || 'Actor'} 
          {talent.age_range && ` • ${talent.age_range}`}
        </p>
        {talent.skills && talent.skills.length > 0 && (
          <div className="talent-card-skills">
            {talent.skills.slice(0, 3).map((skill, idx) => (
              <span key={idx} className="skill-tag">{skill}</span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}
